import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  getAllIncidents,
  getIncident,
  getDropdowns,
  getNewIncident,
} from "./utils";

export const IncidentEntryContext = createContext();

export const IncidentEntryProvider = ({ children }) => {
  const [incidents, setIncidents] = useState(null);
  const [incident, setIncident] = useState(null);
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [newIncident, setNewIncident] = useState(null);
  const [reload, setReload] = useState(true);
  const [authenticationChecked, setAuthenticationChecked] = useState("Success");
  const [dropdowns, setDropdowns] = useState(null);
  const [errorDialog, setErrorDialog] = useState({
    open: false,
    title: "",
    message: "",
  });

  const fetchIncidents = useCallback(() => {
    getAllIncidents(setIncidents, setAuthenticationChecked);
  }, []);

  const fetchNewIncident = useCallback(() => {
    getNewIncident(setNewIncident, setErrorDialog);
  }, []);

  useEffect(() => {
    if (reload) {
      fetchIncidents();
      setReload(false);
    }
  }, [fetchIncidents, reload]);

  useEffect(() => {
    if (selectedIncident !== null && selectedIncident.id !== null) {
      getIncident(selectedIncident.id, setIncident, setErrorDialog);
      getDropdowns(setDropdowns);
    } else if (selectedIncident === null) {
      setIncident(null);
    }
  }, [selectedIncident]);

  useEffect(() => {
    if (newIncident !== null) {
      getDropdowns(setDropdowns);
    }
  }, [newIncident]);

  return (
    <IncidentEntryContext.Provider
      value={{
        incidents,
        selectedIncident,
        incident,
        newIncident,
        setIncident,
        setSelectedIncident,
        setNewIncident,
        setReload,
        authenticationChecked,
        dropdowns,
        setDropdowns,
        errorDialog,
        setErrorDialog,
        fetchNewIncident,
      }}
    >
      {children}
    </IncidentEntryContext.Provider>
  );
};

export const useIncidents = () => {
  const context = useContext(IncidentEntryContext);
  if (!context) {
    throw new Error(
      "useIncidents must be used with in a IncidentEntryProvider",
    );
  }
  return context;
};
